<template>
  <div class="badgeBox">
    <div class="container">
      <img
        ref="badge"
        :class="['item',datas.length>1&&startAnimation==3?'animation3':'',datas.length==1&&startAnimation==3?'animation3':'',datas.length>1&&startAnimation==2?'animation2':'',startAnimation==1&&(datas.length%2==0||(datas.length%2==1&&(Math.floor(datas.length/2)!=index)))?'animation1':'animation1_single']"
        v-for="(item, index) in datas"
        :key="item.batchId"
        :src="item.imageUrl"
        :style="{left:moveX_badge+index*(elew+37)+'px',top:moveY_badge+'px','z-index':getZindex[index],'animation-delay':startAnimation==3&&datas.length>1?(datas.length-getZindex[index])*0.1+'s':'',width:elew+'px',height:elew+'px' }"
      >
      <div
        :style="{top:moveY_badge+'px'}"
        :class="['animationBox',animationReset?'animationReset':'']"
      >
        <div
          :style="{transform:'rotate('+ Math.floor(Math.random()*100)+ 'deg)'}"
          class="area area1"
        >
          <!--  往左上飞出距离较长 -->
          <img
            class="particle fraction2 outer"
            src="../../../assets/img/video/2.png"
            style="top:-4%; left:126%;width:13px; height:8px;"
          >

          <img
            class="particle fraction5 outer"
            src="../../../assets/img/video/4.png"
            style="top:153%; left:106%;width:10px; height:15px;"
          >

          <img
            class="particle fraction6 outer"
            src="../../../assets/img/video/5.png"
            style="top:25%; left:134%;width:8px; height:12px;"
          >

          <img
            class="particle fraction8 outer"
            src="../../../assets/img/video/1.png"
            style="top:25%; left:-15%;width:12px; height:15px;"
          >

          <img
            class="particle fraction9 outer"
            src="../../../assets/img/video/7.png"
            style="top:99%; left:122%;width:15px; height:13px;"
          >

          <img
            class="particle fraction10 outer"
            src="../../../assets/img/video/5.png"
            style="top:-20%; left:56%;width:8px; height:12px;"
          >
          <img
            class="particle fraction11 outer"
            src="../../../assets/img/video/4.png"
            style="top:0%; left:64%;width:11px; height:15px;"
          >

          <img
            class="particle fraction12 outer"
            src="../../../assets/img/video/2.png"
            style="top:138%; left:81%;width:12px; height:8px;"
          >

          <img
            class="particle fraction13 outer"
            src="../../../assets/img/video/1.png"
            style="top:18%; left:109%;width:13px; height:15px;"
          >
          <img
            class="particle fraction14 outer"
            src="../../../assets/img/video/2.png"
            style="top:-10%; left:81%;width:12px; height:8px;"
          >

          <img
            class="particle fraction15 outer"
            src="../../../assets/img/video/4.png"
            style="top:61%; left:143%;width:12px; height:15px;"
          >
          <img
            class="particle fraction16 outer"
            src="../../../assets/img/video/5.png"
            style="top:0%; left:-4%;width:8px; height:12px;"
          >

          <img
            class="particle fraction17 outer"
            src="../../../assets/img/video/4.png"
            style="top:126%; left:-4%;width:11px; height:15px;"
          >

          <img
            class="particle fraction20 outer"
            src="../../../assets/img/video/7.png"
            style="top:87%; left:-26%;width:15px; height:12px;"
          >

          <img
            class="particle fraction22 outer"
            src="../../../assets/img/video/4.png"
            style="top:58%; left:-31%;width:12px; height:15px;"
          >

          <img
            class="particle fraction23 outer"
            src="../../../assets/img/video/2.png"
            style="top:128%; left:47%;width:12px; height:8px;"
          >

          <img
            class="particle fraction25 outer"
            src="../../../assets/img/video/4.png"
            style="top:86%; left:75%;width:11px; height:15px;"
          >
          <img
            class="particle fraction26 outer"
            src="../../../assets/img/video/5.png"
            style="top:151%; left:45%;width:8px; height:13px;"
          >
          <img
            class="particle fraction27 outer"
            src="../../../assets/img/video/6.png"
            style="top:162%; left:70%;width:10px; height:13px;"
          >
          <img
            class="particle fraction28 outer"
            src="../../../assets/img/video/7.png"
            style="top:127%; left:20%;width:15px; height:13px;"
          >

          <img
            class="particle fraction29 outer"
            src="../../../assets/img/video/8.png"
            style="top:-5%; left:20%;width:12px; height:13px;"
          >

          <img
            class="particle fraction31 outer"
            src="../../../assets/img/video/6.png"
            style="top:152%; left:8%;width:13px; height:15px;"
          >
          <img
            class="particle fraction32 outer"
            src="../../../assets/img/video/5.png"
            style="top:23%; left:74%;width:10px; height:13px;"
          >
          <img
            class="particle fraction33 outer"
            src="../../../assets/img/video/4.png"
            style="top:124%; left:130%;width:12px; height:15px;"
          >

          <img
            class="particle fraction40 outer"
            src="../../../assets/img/video/3.png"
            style="top:139%; left:-26%;width:12px; height:11px;"
          >

          <!--内圈开始-->
          <img
            class="particle fraction19 inner"
            src="../../../assets/img/video/7.png"
            style="top:81%; left:-8%;width:16px; height:14px;"
          >
          <img
            class="particle fraction36 inner"
            src="../../../assets/img/video/2.png"
            style="top:68%; left:-6%;width:13px; height:8px;"
          >

          <img
            class="particle fraction38 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:13px; height:15px;"
          >
          <img
            class="particle fraction30 inner"
            src="../../../assets/img/video/7.png"
            style="top:18%; left:38%;width:15px; height:13px;"
          >

          <img
            class="particle fraction21 inner"
            src="../../../assets/img/video/5.png"
            style="top:105%; left:79%;width:8px; height:14px;"
          >
          <img
            class="particle fraction24 inner"
            src="../../../assets/img/video/2.png"
            style="top:102%; left:20%;width:12px; height:12px;"
          >
          <img
            class="particle fraction34 inner"
            src="../../../assets/img/video/2.png"
            style="top:33%; left:102%;width:12px; height:6px;"
          >
          <img
            class="particle fraction35 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:12px; height:15px;"
          >
        </div>
        <div
          :style="{transform:'rotate('+ Math.floor(Math.random()*100)+ 'deg)'}"
          class="area area2"
        >
          <!--  往左上飞出距离较长 -->
          <img
            class="particle fraction2 outer"
            src="../../../assets/img/video/2.png"
            style="top:-4%; left:126%;width:13px; height:8px;"
          >

          <img
            class="particle fraction5 outer"
            src="../../../assets/img/video/4.png"
            style="top:153%; left:106%;width:10px; height:15px;"
          >

          <img
            class="particle fraction6 outer"
            src="../../../assets/img/video/5.png"
            style="top:25%; left:134%;width:8px; height:12px;"
          >

          <img
            class="particle fraction8 outer"
            src="../../../assets/img/video/1.png"
            style="top:25%; left:-15%;width:12px; height:15px;"
          >

          <img
            class="particle fraction9 outer"
            src="../../../assets/img/video/7.png"
            style="top:99%; left:122%;width:15px; height:13px;"
          >

          <img
            class="particle fraction10 outer"
            src="../../../assets/img/video/5.png"
            style="top:-20%; left:56%;width:8px; height:12px;"
          >
          <img
            class="particle fraction11 outer"
            src="../../../assets/img/video/4.png"
            style="top:0%; left:64%;width:11px; height:15px;"
          >

          <img
            class="particle fraction12 outer"
            src="../../../assets/img/video/2.png"
            style="top:138%; left:81%;width:12px; height:8px;"
          >

          <img
            class="particle fraction13 outer"
            src="../../../assets/img/video/1.png"
            style="top:18%; left:109%;width:13px; height:15px;"
          >
          <img
            class="particle fraction14 outer"
            src="../../../assets/img/video/2.png"
            style="top:-10%; left:81%;width:12px; height:8px;"
          >

          <img
            class="particle fraction15 outer"
            src="../../../assets/img/video/4.png"
            style="top:61%; left:143%;width:12px; height:15px;"
          >
          <img
            class="particle fraction16 outer"
            src="../../../assets/img/video/5.png"
            style="top:0%; left:-4%;width:8px; height:12px;"
          >

          <img
            class="particle fraction17 outer"
            src="../../../assets/img/video/4.png"
            style="top:126%; left:-4%;width:11px; height:15px;"
          >

          <img
            class="particle fraction20 outer"
            src="../../../assets/img/video/7.png"
            style="top:87%; left:-26%;width:15px; height:12px;"
          >

          <img
            class="particle fraction22 outer"
            src="../../../assets/img/video/4.png"
            style="top:58%; left:-31%;width:12px; height:15px;"
          >

          <img
            class="particle fraction23 outer"
            src="../../../assets/img/video/2.png"
            style="top:128%; left:47%;width:12px; height:8px;"
          >

          <img
            class="particle fraction25 outer"
            src="../../../assets/img/video/4.png"
            style="top:86%; left:75%;width:11px; height:15px;"
          >
          <img
            class="particle fraction26 outer"
            src="../../../assets/img/video/5.png"
            style="top:151%; left:45%;width:8px; height:13px;"
          >
          <img
            class="particle fraction27 outer"
            src="../../../assets/img/video/6.png"
            style="top:162%; left:70%;width:10px; height:13px;"
          >
          <img
            class="particle fraction28 outer"
            src="../../../assets/img/video/7.png"
            style="top:127%; left:20%;width:15px; height:13px;"
          >

          <img
            class="particle fraction29 outer"
            src="../../../assets/img/video/8.png"
            style="top:-5%; left:20%;width:12px; height:13px;"
          >

          <img
            class="particle fraction31 outer"
            src="../../../assets/img/video/6.png"
            style="top:152%; left:8%;width:13px; height:15px;"
          >
          <img
            class="particle fraction32 outer"
            src="../../../assets/img/video/5.png"
            style="top:23%; left:74%;width:10px; height:13px;"
          >
          <img
            class="particle fraction33 outer"
            src="../../../assets/img/video/4.png"
            style="top:124%; left:130%;width:12px; height:15px;"
          >

          <img
            class="particle fraction40 outer"
            src="../../../assets/img/video/3.png"
            style="top:139%; left:-26%;width:12px; height:11px;"
          >

          <!--内圈开始-->
          <img
            class="particle fraction19 inner"
            src="../../../assets/img/video/7.png"
            style="top:81%; left:-8%;width:16px; height:14px;"
          >
          <img
            class="particle fraction36 inner"
            src="../../../assets/img/video/2.png"
            style="top:68%; left:-6%;width:13px; height:8px;"
          >

          <img
            class="particle fraction38 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:13px; height:15px;"
          >
          <img
            class="particle fraction30 inner"
            src="../../../assets/img/video/7.png"
            style="top:18%; left:38%;width:15px; height:13px;"
          >

          <img
            class="particle fraction21 inner"
            src="../../../assets/img/video/5.png"
            style="top:105%; left:79%;width:8px; height:14px;"
          >
          <img
            class="particle fraction24 inner"
            src="../../../assets/img/video/2.png"
            style="top:102%; left:20%;width:12px; height:12px;"
          >
          <img
            class="particle fraction34 inner"
            src="../../../assets/img/video/2.png"
            style="top:33%; left:102%;width:12px; height:6px;"
          >
          <img
            class="particle fraction35 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:12px; height:15px;"
          >
        </div>
      </div>
      <transition name="fade">
        <div v-if="showText" :style="{top:moveY_txt+'px', }" class="text_part">
          <p class="txt">您获得了</p>
          <p class="badgeItem">{{badgeNames}}徽章</p>
          <span class="close cursor" @click="closeWindow"></span>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      startAnimation: 0,
      moveX_badge: 0,
      moveY_badge: 0,
      moveY_txt: 0,
      showText: false,
      animationReset: false,
      timer1: null,
      timer2: null,
      uploadSuccess: false,
      lastClickTime: 0
    };
  },
  props: {
    datas: {
      type: Array,
      required: true
    }
  },
  computed: {
    badgeNames() {
      let str = "";
      this.datas.forEach(item => {
        str += item.title + "、";
      });
      return str.substring(0, str.lastIndexOf("、"));
    },
    batch_ids() {
      let str = "";
      this.datas.forEach(item => {
        str += item.batchId + ",";
      });
      return str.substring(0, str.lastIndexOf(","));
    },
    elew() {
      if (this.datas.length > 2) {
        return 154;
      } else {
        return 200;
      }
    },
    getZindex() {
      let arr = [];
      let length = this.datas.length + 1;
      for (let i = 0; i < this.datas.length; i++) {
        if (this.datas.length % 2 == 1) {
          i % 2 == 0 ? arr.unshift(length--) : arr.push(length--);
        } else {
          i % 2 == 0 ? arr.push(length--) : arr.unshift(length--);
        }
      }

      return arr;
    }
  },
  created() {
    window.onresize = this.initData;
  },
  mounted() {
    this.uploadBadge({ batch_ids: this.batch_ids }).then(({ res, ok }) => {
      if (ok) {
        this.uploadSuccess = true;
      }
    });
    setTimeout(() => {
      this.initData();
      this.startAnimation = 1;
      this.showText = true;
    }, 1000);
    if (this.datas.length == 1) {
      this.timer1 = setInterval(() => {
        this.animationReset = true;
      }, 1300);
      this.timer2 = setInterval(() => {
        this.animationReset = false;
      }, 4000);
    }
  },
  methods: {
    ...mapMutations(["updateBadge"]),
    ...mapActions(["uploadBadge"]),
    initData() {
      this.moveX_badge =
        (document.body.clientWidth -
          (this.datas.length * this.$refs.badge[0].width +
            this.datas.length * 30)) /
          2 +
        10;
      this.moveY_badge = (document.body.clientHeight - 300) / 2;
      this.moveY_txt = (document.body.clientHeight - 300) / 2 + 220;
      let obj = this.$parent.$children[0].$refs.badge;
      //console.log("moveX_badge", this.moveX_badge);

      let styleObj = `
          @keyframes remove1 {
          0% {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
            opacity: 1;
          }
          99% {
            top:  -${obj.offsetTop - (this.datas.length > 2 ? 38 : 14)}px;
          left: ${obj.offsetLeft - this.$refs.badge[0].width / 2 + 26}px;
            position: absolute;
            transform: scale(0.1);
            opacity: 1;
          }
          100% {
            top:   -${obj.offsetTop - (this.datas.length > 2 ? 38 : 14)}px;
            left: ${obj.offsetLeft - this.$refs.badge[0].width / 2 + 26}px;
            position: absolute;
            opacity: 0;
          }
        }
        `;

      let ele = document.createElement("style");
      ele.textContent = styleObj;
      document.body.appendChild(ele);
    },
    closeWindow() {
      if (
        Date.now() - this.lastClickTime <
        800 + this.datas.length * 1000 - (this.datas.length - 1) * 800
      )
        return;
      this.lastClickTime = Date.now();
      this.showText = false;
      clearInterval(this.timer1);
      clearInterval(this.timer2);
      this.startAnimation = 2;
      setTimeout(() => {
        this.startAnimation = 3;
      }, 600 * (this.datas.length > 1 ? 1 : 0));
      setTimeout(() => {
        if (this.uploadSuccess) {
          this.updateBadge({ num: this.datas.length });
        }
        this.$root.eventHub.$emit("showPopup", "c_badgeBox");
      }, this.datas.length * 1000 - (this.datas.length - 1) * 600);
    }
  },
  beforeDestroy(){
    window.onresize = null;
  }
};
</script>
<style lang="less" scoped>
.badgeBox {
  z-index: 998;
  height: 100%;
  width: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    .close {
      width: 40px;
      height: 40px;
      margin: 30px auto 0;
      background: url("../../../assets/img/basic/announce/announce_close.png")
        no-repeat center;
      background-size: 40px;
    }
    .item {
      position: absolute;
      left: 0;
      // transform: translateX(-50%);
      width: 154px;
      height: 154px;
      opacity: 0;
    }
    .text_part {
      position: absolute;
      color: #fff;
      transform: translatex(-50%);
      left: 50%;
      height: 215px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .txt {
        position: relative;
        font-size: 21px;
        margin-bottom: 10px;
        width: 200px;
        margin: 0 auto 10px;
      }
      .badgeItem {
        display: inline;
        position: relative;
        font-size: 24px;
        font-weight: 700;
      }
        .txt::before {
          display: block;
          background: linear-gradient(to left,rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0)); /* 标准的语法 */
          width: 50px;
          height: 2px;
          content: "";
          position: absolute;
          left: -3px;
          top: 14px;
          border-radius: 1px;
        }
        .txt::after {
          display: block;
          border-radius: 1px;
          background: linear-gradient(to right,rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
          width: 50px;
          height: 2px;
          content: "";
          position: absolute;
          right: 2px;
          top: 14px;
        }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.8s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .animation1 {
      //徽章入场动画
      animation: move cubic-bezier(0.645, 0.045, 0.355, 1) 0.8s both;
    }
    .animation1_single {
      //中间徽章入场动画
      animation: single cubic-bezier(0.645, 0.045, 0.355, 1) 0.8s 1s both;
    }
    .animation2 {
      animation: remove cubic-bezier(0.645, 0.045, 0.355, 1) 0.5s both;
    }
    .animation3 {
      animation: remove1 cubic-bezier(0.645, 0.045, 0.355, 1) 0.8s both;
    }
  }
}

@keyframes single {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes move {
  0% {
    left: 50%;
    position: absolute;
    transform: translateX(-50%) scale(0);
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes remove {
  0% {
    opacity: 1;
  }
  100% {
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    opacity: 1;
  }
}

.animationBox {
  position: absolute;

  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;
  .area {
    width: 140px;
    height: 140px;
    position: absolute;

    z-index: 80;
    .particle {
      opacity: 0;
      position: absolute;
      transform: scale(0.7);
    }
  }
  /*粒子动画*/
  .area1 {
    top: -83%;
    left: -80%;
  }
  .area2 {
    left: 118%;
    top: 78%;
  }
}

.animationReset {
  .area1 {
    .outer {
      animation: aaa 0.6s 0.2s ease-in-out;
    }
    .inner {
      animation: aaa 0.5s ease-in-out;
    }
  }
  .area2 {
    .outer {
      animation: aaa 0.6s 0.6s ease-in-out;
    }
    .inner {
      animation: aaa 0.5s 0.4s ease-in-out;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/badgeBox/badgebox.vue